import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { useClientSideNav } from '@ecosystem/newron-client-lib';

interface MobileContextProps {
  isMobile: boolean;
}

const MobileContext = createContext<MobileContextProps | undefined>(undefined);

export const MobileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = React.useState(false);
  const { setExpanded } = useClientSideNav();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      setExpanded(false);

      const contentElement = document.getElementById('newron-content');
      if (contentElement) {
        contentElement.style.setProperty('margin-left', '0', 'important');
      }
    }
  }, [isMobile, setExpanded]);

  return <MobileContext.Provider value={{ isMobile }}>{children}</MobileContext.Provider>;
};

export const useMobile = (): MobileContextProps => {
  const mobile = useContext(MobileContext);
  if (!mobile) {
    return { isMobile: false };
  }
  return mobile;
};
